import { useContext } from 'react';
import {
  TimestampFormatContext,
  type TimestampFormatContextType,
} from '@/contexts/TimestampFormatContext';

/**
 * Consumer hook for the per-user Timestamp Format setting. Reads from
 * `TimestampFormatContext`; provider-less consumers get the context default
 * (`'relative'`). Mirrors `useLayout` / `useThemeContext`.
 */
export function useTimestampFormat(): TimestampFormatContextType {
  return useContext(TimestampFormatContext);
}
